// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowAboveOutlinedSvg from "@ant-design/icons-svg/es/asn/InsertRowAboveOutlined";
import AntdIcon from '../components/AntdIcon';

var InsertRowAboveOutlined = function InsertRowAboveOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowAboveOutlinedSvg
  }));
};

InsertRowAboveOutlined.displayName = 'InsertRowAboveOutlined';
export default React.forwardRef(InsertRowAboveOutlined);